import ReactDom from 'react-dom/client'
import App from './App'
import { oauth2 as SMART } from "fhirclient"
import { AdministrationsStateProvider } from './components/state'
import './index.css'

let clientId: string = ''

const GetClientId = (clientId: string) => {
  if (clientId === '') {
    const query = window.location.toString().split('?')[1]
    const queryParams = query && new URLSearchParams(query)
    const urlId = (queryParams && queryParams.get('clientId')) ?? 'undefined'

    return urlId
  }

  return clientId
}

clientId = GetClientId(clientId)

const root = ReactDom.createRoot(document.getElementById('root') as HTMLElement)

SMART.init({
  redirectUri: "",
  clientId: clientId,
  scope: 'launch/patient online_access openid profile launch patient/*.* user/*.*',
  completeInTarget: true
})
  .then(client => {
    root.render(
      <AdministrationsStateProvider>
        <App client={client} />
      </AdministrationsStateProvider>
    )
  })
